/* eslint-disable import/no-mutable-exports, getter-return */
var noop = function () { };
var isSupported = false;
/**
 * Checks if the browser supports passive events. This shouldn't really be used
 * outside of this file, but you can always check again if needed.
 */
export function update() {
    if (typeof window === "undefined") {
        return false;
    }
    var isPassiveEventsSupported = false;
    var opts = Object.defineProperty({}, "passive", {
        get: function () {
            isPassiveEventsSupported = true;
        },
    });
    window.addEventListener("testSupportsPassive", noop, opts);
    window.removeEventListener("testSupportsPassive", noop, opts);
    isSupported = isPassiveEventsSupported;
    return isPassiveEventsSupported;
}
// invoke immediately
update();
export { isSupported };
//# sourceMappingURL=passiveEvents.js.map